<div class="modal-header">
  <h4 class="modal-title">{{'AddOrUpdateEmailToAccount' | translate}}</h4>
  <!--
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  -->
</div>
<div class="modal-body" >
  <ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>
  <alert></alert>
  <form  name="myForm" #myForm="ngForm" class="form-horizontal">
    <div class="emprez-orange-fiesta" style="font-size: larger;margin-bottom: 15px;">{{'ShouldAddOrUpdateAnEmailToYourAccount' | translate }}</div>

    <div class="form-group">
      <label >{{'Email' | translate}}</label>
      <input required class="form-control" [focus]="focusEmail" name="email" [(ngModel)]="email" type="email" maxlength="100">
    </div>

  </form>
</div>


<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!myForm.form.valid || !isEmailValid()" (click)="onUpdate()">{{'Update' | translate}}</button>
  <!--<button type="button" class="btn btn-link" (click)="onCancel()">{{'Cancel' | translate}}</button>-->
</div>

